import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function ParetiVentilate() {
  return (
    <SpecializationPage
      testid="pareti-ventilate-page"
      quoteService="Pareti ventilate"
      index="/ 08"
      title="Pareti Ventilate"
      lines={["Pareti", "ventilate."]}
      subtitle="Il sistema di facciata più evoluto: un rivestimento esterno staccato dalla parete che protegge l'edificio, lo isola e ne trasforma l'estetica."
      image={IMG.facade}
      accent="Estetica e prestazioni, in una sola facciata."
      intro={[
        "La parete ventilata è un sistema di rivestimento esterno fissato a una sottostruttura, che crea un'intercapedine d'aria tra il rivestimento e lo strato isolante. Questa camera d'aria innesca un moto convettivo naturale che allontana calore e umidità.",
        "Il risultato è un involucro che protegge l'edificio dagli agenti atmosferici, migliora l'isolamento termo-acustico, elimina condensa e muffe e offre infinite possibilità estetiche con materiali di pregio.",
      ]}
      specs={[
        { k: "Intercapedine", v: "3-8 cm" },
        { k: "Isolamento acustico", v: "Elevato" },
        { k: "Ventilazione", v: "Naturale" },
        { k: "Condensa", v: "Eliminata" },
        { k: "Rivestimenti", v: "Gres · Pietra · HPL" },
        { k: "Durata", v: "> 50 anni" },
      ]}
      benefits={[
        { t: "Comfort termico", d: "L'intercapedine ventilata riduce il surriscaldamento estivo e le dispersioni invernali." },
        { t: "Isolamento acustico", d: "Migliora sensibilmente l'abbattimento dei rumori esterni." },
        { t: "Addio umidità", d: "La ventilazione naturale elimina condensa, muffe e infiltrazioni." },
        { t: "Estetica su misura", d: "Ampia scelta di finiture: gres porcellanato, pietra, laminati e metallo." },
        { t: "Protezione della struttura", d: "Il rivestimento protegge le murature dagli agenti atmosferici." },
        { t: "Durabilità elevata", d: "Sistema a secco, ispezionabile e con vita utile molto lunga." },
      ]}
      applications={[
        "Facciate di edifici residenziali",
        "Edifici plurifamiliari e condomini",
        "Riqualificazione di facciate esistenti",
        "Nuove costruzioni",
        "Edifici commerciali e direzionali",
        "Ville e residenze di pregio",
        "Rivestimenti in gres porcellanato",
        "Rivestimenti in pietra naturale",
        "Rivestimenti in HPL e laminati",
        "Rivestimenti in fibrocemento",
        "Rivestimenti metallici (alluminio, corten)",
        "Basamenti e zoccolature",
        "Facciate ad alte prestazioni energetiche",
        "Edifici pubblici e scolastici",
        "Cappotti ventilati su cappotto termico",
        "Frangisole e schermature solari",
      ]}
      faqs={[
        { q: "Cos'è esattamente una parete ventilata?", a: "È un sistema di rivestimento esterno fissato a una sottostruttura, che crea un'intercapedine d'aria tra il rivestimento e lo strato isolante. Questa camera d'aria innesca un moto convettivo naturale che allontana calore e umidità dall'edificio." },
        { q: "Elimina davvero condensa e muffe?", a: "Sì. La ventilazione naturale dell'intercapedine favorisce lo smaltimento dell'umidità e della condensa, prevenendo la formazione di muffe sulle murature." },
        { q: "Quali materiali di rivestimento posso scegliere?", a: "L'offerta è molto ampia: gres porcellanato, pietra naturale, laminati HPL, fibrocemento e metalli come alluminio o corten. Questo consente infinite possibilità estetiche." },
        { q: "Si può realizzare su un edificio esistente?", a: "Sì. La parete ventilata è ideale anche per la riqualificazione di facciate esistenti, migliorandone contemporaneamente estetica, isolamento termico e acustico." },
        { q: "Quanto dura questo sistema?", a: "È un sistema a secco, ispezionabile e con vita utile molto lunga, oltre i 50 anni. I singoli elementi sono facilmente sostituibili in caso di necessità." },
      ]}
    />
  );
}
